import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Form, Input, Label } from 'reactstrap';

class Footer extends Component {

  constructor(props) {
    super(props);
    this.state = {
        grid1 : [
            { title : "Nosotros", link : "https://jancube.com" },
            // { title : "Precio", link : "/precio" },
            // { title : "Integraciones", link : "/integrations" },
        ],
        grid2 : [
            // { title : "Términos y Condiciones", link : "/terms" },
            { title : "Políticas de Privacidad", link : "/privacy" },
        ]
    };
  }

  render() {
    return (
      <React.Fragment>
        <footer id="footer" className={this.props.isLight ? "footer bg-light" : "footer"}>
            <Container>
                <Row>
                    <Col lg="4" xs="12" className="mb-0 mb-md-4 pb-0 pb-md-2" name="footercolumn">
                        <Link className={this.props.isLight ? "logo-footer text-dark" : "logo-footer"} to="#">Rindo<span className="text-primary"></span></Link>
                        <p className={ this.props.isLight ? "mt-4 text-muted" : "mt-4"}>Agilizamos y resolvemos los problemas de rendición de gastos, facilitando el autoservicio, automatizando los procesos y optimizando la administración.</p>
                        {/* <ul className="list-unstyled social-icon social mb-0 mt-4">
                            <li className="list-inline-item mr-1"><Link to="" className="rounded"><i className="mdi mdi-facebook" title="Facebook"></i></Link></li>
                            <li className="list-inline-item mr-1"><Link to="" className="rounded"><i className="mdi mdi-instagram" title="Instagram"></i></Link></li>
                            <li className="list-inline-item mr-1"><Link to="" className="rounded"><i className="mdi mdi-twitter" title="Twitter"></i></Link></li>
                        </ul> */}
                    </Col>
                
                    <Col lg="2" md="4" xs="12" className="mt-4 mt-sm-0 pt-2 pt-sm-0" name="footercolumn">
                        <h4 className={this.props.isLight ? "text-dark footer-head" : "text-light footer-head"}></h4>
                        <ul className="list-unstyled footer-list mt-4">
                            {
                                this.state.grid1.map((grid, key) =>
                                <li key={key}><a href={grid.link} className={this.props.isLight ? "text-muted" : "text-foot"}><i className="mdi mdi-chevron-right mr-1"></i> {grid.title}</a></li>
                                )
                            }
                        </ul>
                    </Col>
                    
                    <Col lg="3" md="4" xs="12" className="mt-4 mt-sm-0 pt-2 pt-sm-0" name="footercolumn">
                        <h4 className={this.props.isLight ? "text-dark footer-head" : "text-light footer-head"}></h4>
                        <ul className="list-unstyled footer-list mt-4">
                            {
                                this.state.grid2.map((grid, key) =>
                                <li key={key}><Link to={grid.link} className={this.props.isLight ? "text-muted" : "text-foot"}><i className="mdi mdi-chevron-right mr-1"></i> {grid.title}</Link></li>
                                )
                            }
                        </ul>
                    </Col>

                    <Col lg="3" md="4" xs="12" className="mt-4 mt-sm-0 pt-2 pt-sm-0" name="footercolumn">
                        <h4 className={this.props.isLight ? "text-dark footer-head" : "text-light footer-head"}>Solicita una Demo</h4>
                        <p className="mt-4">Selecciona la fecha y hora que más te acomode para realizar la reunión.</p>
                        <Form>
                            <Row>
                                {/* <Col lg="12">
                                    <div className={this.props.isLight ? "foot-subscribe foot-white form-group position-relative" : "foot-subscribe form-group position-relative"}>
                                        <Label className={this.props.isLight ? "text-muted" : ""}>Escribe tu correo <span className="text-danger">*</span></Label>
                                        <i className="mdi mdi-email ml-3 icons"></i>
                                        <Input type="email" name="email" id="emailsubscribe" className={this.props.isLight ? "form-control bg-light border pl-5 rounded" : "form-control pl-5 rounded"} placeholder="Tu correo : " required/>
                                    </div>
                                </Col> */}
                                <Col lg="12">
                                    {/* <Input type="submit" id="submitsubscribe" name="send" className="btn btn-primary rounded w-100" value="Enviar"/> */}
                                    <a href="https://calendly.com/jpbarahona/demo-rindo" target="_blank" className="btn btn-primary mt-2">Agendar</a>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Container>
        </footer>
        <footer className="footer footer-bar">
            <Container className="text-center">
                <Row className="align-items-center">
                    <Col sm="6">
                        <div className="text-sm-left">
                            <p className="mb-0">© {new Date().getFullYear()} Rindo. Desarrollado por <a href="https://jancube.com" target="_blank" className="text-success">Jancube</a>.</p>
                        </div>
                    </Col>

                    {/* <Col sm="6" className="mt-4 mt-sm-0 pt-2 pt-sm-0">
                        <ul className="list-unstyled text-sm-right mb-0">
                            <li className="list-inline-item mr-1"><Link to=""><img src={americanEx} className="avatar avatar-ex-sm" title="American Express" alt=""/></Link></li>
                            <li className="list-inline-item mr-1"><Link to=""><img src={discover} className="avatar avatar-ex-sm" title="Discover" alt=""/></Link></li>
                            <li className="list-inline-item mr-1"><Link to=""><img src={masterCard} className="avatar avatar-ex-sm" title="Master Card" alt=""/></Link></li>
                            <li className="list-inline-item mr-1"><Link to=""><img src={paypal} className="avatar avatar-ex-sm" title="Paypal" alt=""/></Link></li>
                            <li className="list-inline-item mr-1"><Link to=""><img src={visa} className="avatar avatar-ex-sm" title="Visa" alt=""/></Link></li>
                        </ul>
                    </Col> */}
                </Row>
            </Container>
        </footer>        
      </React.Fragment>
    );
  }
}

export default Footer;
